<div class="content">
    <h1 class="page-title">Calendário 2020</h1>
    <p>
        Com base no panorama atual, sem previsão de alteração quanto às
        recomendações de isolamento social decorrentes do avanço do Coronavírus
        (COVID-19) em todo o país, e no intuito de preservar a integridade dos
        nossos&nbsp;treinadores, informamos que o Departamento de Capacitação
        adiará a realização dos cursos de formação até o dia 30 de junho: Gira
        Nacional CBT; Módulo B – Itajaí/SC; Módulo B – Uberlândia/MG; Módulo D –
        Campo Grande/MS;&nbsp;Módulo A – Rio de Janeiro/RJ; Módulo A
        –&nbsp;Passo Fundo/RS; Módulo C –&nbsp;Uberlândia/MG;&nbsp;Curso de
        Capacitação Professores e Administradores de Clubes e Academias&nbsp;
        –&nbsp;Sinop (MT).
    </p>

    <p>
        Tão logo a situação esteja sob controle, faremos a atualização do
        calendário visando atender as regiões e treinadores que tiveram as
        formações adiadas.
    </p>

    <p>
        Seguiremos atentos a todas as recomendações, com a certeza de que em
        breve poderemos voltar à normalidade.
    </p>

    <p>
        Pedimos que acompanhem os nossos canais de comunicação e nos colocamos à
        disposição de todos para qualquer esclarecimento.
    </p>

    <p>Atenciosamente,</p>

    <p>
        Caio Cortela<br />
        Departamento de Capacitação da CBT
    </p>
</div>
